import React, { FC } from "react";

import { toast } from "react-toastify";

import { useApisAdminOperatorsCompaniesFeatureFlagsUpdate } from "~/hooks";

import { FeatureFlagType } from "~/domains";

import { Button } from "~/ui";

type PropsType = {
  companyId: string;
  featureFlags: FeatureFlagType[];
  refetch: () => void;
};

export const FeatureFlagList: FC<PropsType> = ({
  companyId,
  featureFlags,
  refetch,
}) => {
  const { mutate: updateFeatureFlag, isLoading } =
    useApisAdminOperatorsCompaniesFeatureFlagsUpdate();

  const handleToggle = (featureKey: string, currentEnabled: boolean) => {
    const newEnabled = !currentEnabled;

    updateFeatureFlag(
      {
        companyId,
        featureKey,
        body: { enabled: newEnabled },
      },
      {
        onSuccess: (data) => {
          toast(data.message);
          refetch();
        },
      },
    );
  };

  return (
    <div className="mt-4">
      <h2 className="text-lg font-bold text-gray-900 mb-3">機能フラグ</h2>

      <div className="space-y-2">
        {featureFlags.map((flag) => (
          <div
            key={flag.key}
            className="flex items-center justify-between px-4 py-3 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
          >
            <div className="flex items-center gap-3">
              <span className="font-medium text-gray-900">{flag.key}</span>
              <span
                className={`px-2 py-0.5 rounded text-xs font-bold ${
                  flag.enabled
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {flag.enabled ? "ON" : "OFF"}
              </span>
            </div>

            <Button
              text={flag.enabled ? "OFFにする" : "ONにする"}
              color={flag.enabled ? "gray" : "primary"}
              outline
              onClick={() => handleToggle(flag.key, flag.enabled)}
              readonly={isLoading}
              className="min-w-[60px] text-sm"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
